/**
 * @generated SignedSource<<a3a6e589e49f620f7a68074714aec007>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterPanelActionsFragment$data = {
  readonly statement: {
    readonly discord: string;
    readonly twitter: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelActionsDelegateButtonFragment">;
  readonly " $fragmentType": "VoterPanelActionsFragment";
};
export type VoterPanelActionsFragment$key = {
  readonly " $data"?: VoterPanelActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterPanelActionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterPanelActionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateStatement",
      "kind": "LinkedField",
      "name": "statement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "twitter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discord",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoterPanelActionsDelegateButtonFragment"
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "273af5b332c9f6b0db0615db02fbaf20";

export default node;
